// Compact date presentation shared by the admin list and detail views.
const minuteMilliseconds = 60 * 1000;
const dayMilliseconds = 24 * 60 * minuteMilliseconds;

// List rows: time if today, weekday within the week, date otherwise
export function formatListDate(isoString) {
  if (!isoString) return "";
  const date = new Date(isoString);
  const ageDays = (Date.now() - date.getTime()) / dayMilliseconds;
  if (ageDays < 1 && date.getDate() === new Date().getDate()) {
    return date.toLocaleTimeString("en-AU", {hour: "numeric", minute: "2-digit"});
  }
  if (ageDays < 6) return date.toLocaleDateString("en-AU", {weekday: "long"});
  return date.toLocaleDateString("en-AU", {day: "numeric", month: "short", year: "numeric"});
}

// Detail headers: "3 mins" / "5 hrs" / "Yesterday" / dd/mm/yyyy
export function formatCompactDate(isoString) {
  if (!isoString) return "";
  const date = new Date(isoString);
  const minutesAgo = Math.max(0, Math.round((Date.now() - date.getTime()) / minuteMilliseconds));
  if (minutesAgo < 60) return `${minutesAgo} min${minutesAgo === 1 ? "" : "s"}`;
  const startOfToday = new Date().setHours(0, 0, 0, 0);
  if (date.getTime() >= startOfToday) return `${Math.round(minutesAgo / 60)} hrs`;
  if (date.getTime() >= startOfToday - dayMilliseconds) return "Yesterday";
  return date.toLocaleDateString("en-AU", {day: "2-digit", month: "2-digit", year: "numeric"});
}

// Detail headers with the time: "Yesterday · 3:42 pm"
export function formatCompactDateTime(isoString) {
  if (!isoString) return "";
  const time = new Date(isoString).toLocaleTimeString("en-AU", {hour: "numeric", minute: "2-digit"});
  return `${formatCompactDate(isoString)} · ${time}`;
}

// Phone display: AU mobiles as "0417 272 668", anything else as-is
export function formatDisplayPhone(phoneNumber) {
  const digits = String(phoneNumber ?? "").replace(/\D/g, "");
  const local = digits.startsWith("61") && digits.length === 11 ? `0${digits.slice(2)}` : digits;
  if (local.length !== 10) return String(phoneNumber ?? "");
  return `${local.slice(0, 4)} ${local.slice(4, 7)} ${local.slice(7)}`;
}
